import React from 'react';
import styles from './TextGroupSectionF.module.sass';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import TextContainer from '../../reusable/title_description_group_container/TitleDescriptionGroupContainer';
import { TextGroupStyle } from '../../reusable/title_description_group/TitleDescriptionGroup';
import Caitlyn from '../../assets/caitlyn_photo_most.webp';
import MobileSpacer, { SpacerSize } from '../../reusable/mobile_spacer/MobileSpacer';
import Grid from '../../reusable/grid/Grid';
import RevealImage from '../../reusable/reveal/RevealImage';

const title = "Caitlyn Wild."
const subtitle = "Occupational Therapist"
const paragraphs = [
  "Caitlyn earned her Bachelor of Arts in Kinesiology with a minor in Adaptive Physical Activity from Chico State in 2018. Her passion for working with children led her to discover the field of occupational therapy during an internship at Chico State’s Autism Clinic. That experience inspired her to pursue occupational therapy as a career, and she went on to complete her Master of Science in Occupational Therapy at West Coast University in 2023.",
  "Her clinical experience includes working with children in the areas of sensory integration, early intervention, and mental health. She is passionate about helping children reach their full potential by supporting the foundational skills they need to succeed at school and in daily life. She believes in taking a whole child approach, considering emotional, physical, and sensory needs while using play and creativity as powerful tools for learning. She strives to create a calm, welcoming environment where kids feel safe, supported, and empowered to succeed.",
  "Outside of work, she enjoys yoga, trying new food, taking her dog on long walks, and spending time with friends and family.",
];

export default class TextGroupSectionF extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.mediumDark}>
        <RevealImage className={styles.Shannon} src={Caitlyn} photo />
        <MobileSpacer size={SpacerSize.medium} />
        <Grid>
          <TextContainer
            className={styles.TextContainer}
            dark
            title={title}
            subtitle={subtitle}
            paragraphs={paragraphs} 
            style={TextGroupStyle.small} />
        </Grid>
      </Section>
    )
  }

}